import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "hunt57_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); };

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Global 401 handler: clear stale token and bounce to /login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      const isPublic = ["/", "/login", "/register", "/request-invite", "/how-it-works", "/terms", "/privacy", "/guidelines"].includes(path);
      if (!isPublic && getToken()) {
        setToken(null);
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(err) {
  const status = err?.response?.status;
  const url = err?.config?.url;
  const d = err?.response?.data?.detail;
  if (status === 404) {
    return `Endpoint not found${url ? ` (${url})` : ""}. Try a hard refresh (Cmd/Ctrl+Shift+R) to load the latest app.`;
  }
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export function imgUrl(fileId, opts = {}) {
  if (!fileId) return null;
  if (typeof fileId === "string" && fileId.startsWith("http")) return fileId;
  // Accept a bare number (`imgUrl(id, 320)`) as shorthand for `{w: 320}` so
  // legacy call-sites still benefit from the resize pipeline.
  const w = typeof opts === "number" ? opts : opts.w;
  const qs = w ? `?w=${w}` : "";
  if (typeof fileId === "string" && fileId.startsWith("/api/")) return `${BACKEND_URL}${fileId}${qs}`;
  return `${API_BASE}/files/${fileId}${qs}`;
}
